import { ObjectLinkBlock } from "./components/ObjectLinkBlock";


import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface StructureSidebarLinksProps {
  onLinkClick?: (linkId: string) => void;
  linkedObjectIds?: string[];
}

export default function StructureSidebarLinks({ onLinkClick, linkedObjectIds }: StructureSidebarLinksProps) {
  const { t } = usePlatformTranslation();


  const handleLinkClick = (linkId: string) => {
    if (onLinkClick) {
      onLinkClick(linkId);
    }
  };

  return (
    <div className="p-4">
      <h4 className ="heading-4">{t('platform.layout.structure-menu.objects')}</h4>

      <ObjectLinkBlock />
    </div>
  );
}